export default __webpack_public_path__ + "static/media/Honeywell.fe2772ae.png";